import React, { useEffect, useState, useReducer } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow, buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { gtag4 } from '../../../../utilities/analytics/tracking';

import SalePackages from '../../SalePackagesBlock/SalePackages';
import CellularBannerList from '../Partials/Cellular/CellularBannerList/CellularBannerList';
import CellularSaleFooter from '../Partials/SaleFooter/CellularSaleFooter';
import { goToPage, setErrorText, setCellularSetting, reportDWH, setSelectedAddOn, resetCellularSettingsPage, setCellularServices, onClickCellularItem, setSelectedPackage, setIsDisplayPackageUpgradePopUp, resetCellularTransferPhoneNumberInfo, updateAddons, updateSelectedCellularSettings, setDisplaySubscriberBasedPackage, setSummaryDetails, setIsLoadingShoppingCart } from '../saleJetBlockSlice';
import { createSaleAsync, getPhoneNumbers, reservePhone, getSalePricesAsync, getCustomerAddresses, addCellular, cellularChangePackage } from '../saleBlockAsyncThunk';
import ChooseCellularPlan from '../Partials/Cellular/ChooseCellularPlan/ChooseCellularPlan';
import ChooseNumber from '../Partials/Cellular/ChooseNumber/ChooseNumber';
import ChooseSimType from '../Partials/Cellular/ChooseSimType/ChooseSimType';
import ChooseAddon from '../Partials/Cellular/ChooseAddon/ChooseAddon';
import ChooseCellularServices from '../Partials/Cellular/ChooseCellularServices/ChooseCellularServices';
import PackageForUpgradePopUp from '../Partials/PackageForUpgradePopUp/PackageForUpgradePopUp';
import StickyBar from '../Partials/Cellular/StickyBar/StickyBar';
import {getSimTypeCode, isEsimType} from '../../../../utilities/domain/simTypeConstants';
import { getOrgBenefitsAllocations } from '../saleBlockAsyncThunk';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import { isOrgEmployeeLogin } from '../../OTPLoginBlock/Assets/variables';


const CellularSettingsPage = (props) => {
  const [showCellularServicesPopup, setShowCellularServicesPopup] = useState(false);
  const [showPackageForUpgradePopup, setShowPackageForUpgradePopup] = useState(false);
  const [showEsimPopUp, setShowEsimPopUp] = useState(false);
  const [showIsMyDeviceSupportESIMPopUp, setShowIsMyDeviceSupportESIMPopUp] = useState(false);
  const [addons, setAddons] = useState(groupArrayOfObjects(props.addons));
  const [packages, setPackages] = useState(props.salePackages);

  //page params
  const isNewLineFromFamilyMember = props.cellularPlanForSale == 'newLine';
  const isTransferLineFromFamilyMember = props.magicLinkParameters?.scopeName == 'SALEFAMILYNPQ';

  let leftBtn = { text: 'המשך', onclick: handlePageContinue };
  let rightBtn = { text: 'אני רוצה קו נוסף', isDisplay: (!isTransferLineFromFamilyMember && props.cellularSettingsList?.length < 5), onclick: handleClickAddPhoneBtn };
  let bottomLink = { text: 'אני רוצה קו נוסף עם חבילה שונה', isDisplay: (!isTransferLineFromFamilyMember && !props.isCustomerBasedPackage && props.cellularSettingsList?.length < 5), onclick: handleClickBottomLink };
  let formid = 'saleJet';
  const cellularSetting = props.cellularSettingsList?.find(x => x.isSelected);
  const simPrice = props.simPriceList?.find(x => x.bpKey == cellularSetting.bpKey);
  const isDisplayEsim = props.selectedPackage.isDisplayEsim && (simPrice?.esim != '' && simPrice?.esim != null);
  let isDisplayFooter = !cellularSetting.showPackages;
  if (!isDisplayEsim) {
    props.setCellularSetting({ simType: getSimTypeCode() , showPackages: cellularSetting.showPackages });
  }
  const isOrgEmployee = isOrgEmployeeLogin(props._authentication);
  const isExistsCustomerWithCellular = props.flowType == 'existsCustomer' && props.hasCellular;
  const isShowNewLineBtn = props.flowType == 'existsCustomer' || isOrgEmployee;
  //page params

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: 'cellular_Step3_ChooseLinePage',
      step: '3',
      action: 'ChooseLinePage',
      funnel_name: 'Choose_Package',
    });
    window.scrollTo(0, 0);
    props.setIsLoadingShoppingCart(false);
    if (addons.length > 0) {
      props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'AddOns Displayed' })
    }
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Setting Line Displayed' });

    if (isTransferLineFromFamilyMember) {
      props.setCellularSetting({ step: 2, phoneType: "transfer", phoneNumber: props.magicLinkParameters?.phoneNumber, isValidPhoneNumber: true, simType: '' });
      gtag4({
        event: 'cellular_Step4_NiudLineButton',
        step: '4',
        button: 'ניוד קו',
        action: 'NiudLineButton',
        funnel_name: 'Niud_Line',
      });
    }
    else if(isNewLineFromFamilyMember){
      props.setCellularSetting({ step: 1, phoneType: "new", phoneNumber: '', isValidPhoneNumber: false, simType: '' });
      getNewPhoneNumbers(true);
    }
    else if(!isShowNewLineBtn){
      props.setCellularSetting({ step: 2, phoneType: "transfer", phoneNumber: '', isValidPhoneNumber: false, simType: '' });
      gtag4({
        event: 'cellular_Step4_NiudLineButton',
        step: '4',
        button: 'ניוד קו',
        action: 'NiudLineButton',
        funnel_name: 'Niud_Line',
      });
    }

    if (runSideEffects()) {
      props.setSummaryDetails();
    }
  },
    [],);

  useEffect(() => {
    if (cellularSetting.step == 4 && cellularSetting.orderId != '') {
      window.scrollTo(0, 0);
    }
  }, [cellularSetting.step]);


  let currentPageHeadline = (
    <>
      <CellularBannerList cellularSettingsList={props.cellularSettingsList} onClick={handleOnClickCellularItem} />
      {(isEsimType(cellularSetting.simType) && props.saleBlockData.esimData?.headerRemark?.value) && <StickyBar text={props.saleBlockData.esimData?.headerRemark?.value} />}
    </>
  );

  const spaceBetween = (height, margin, backgroundColor) => {
    const height1 = height ? height : '1px';
    const margin1 = margin ? margin : '48px auto';
    const backgroundColor1 = backgroundColor ? backgroundColor : 'rgba(219, 222, 224, 0.7)';
    return (<div style={{ width: '90%', height: height1, margin: margin1, backgroundColor: backgroundColor1 }} />);
  }

  let currentPageView = (<>
    {cellularSetting.showPackages ?

      <SalePackages
        packages={packages}
        orderType={props.orderType}
        onSelectedPackages={onSelectedPackages}
      /> :

      <div style={{ paddingTop: '32px' }}>
        <ChooseCellularPlan onClickPhoneType={handleClickPhoneType} phoneType={cellularSetting?.phoneType} isShowNewLineBtn={isShowNewLineBtn} isShowUpdatePlanTypeBtn={isExistsCustomerWithCellular} isDisable={isTransferLineFromFamilyMember}  />
        {spaceBetween()}
        <ChooseNumber onPhoneChange={handlePhoneChange} onClickGetMorePhoneNumbers={getNewPhoneNumbers} cellularSetting={cellularSetting} error={props.errorText} isDisable={cellularSetting?.phoneType == '' || isTransferLineFromFamilyMember} />
        {spaceBetween()}
        {isDisplayEsim && <>
          <ChooseSimType isMyPhoneSupportEsim={handleIsMyPhoneSupportEsim} simType={cellularSetting?.simType} showEsimPopUp={showEsimPopUp} toggleEsimPopUp={toggleEsimPopUp} toggleIsMyDeviceSupportESIMPopUp={toggleIsMyDeviceSupportESIMPopUp} onSelectedSimType={handleSelectedSimType} showIsMyDeviceSupportESIMPopUp={showIsMyDeviceSupportESIMPopUp} simPrice={simPrice} esimData={props.saleBlockData.esimData} isDisable={!cellularSetting.isValidPhoneNumber} />
          {spaceBetween()}
        </>}
        {addons.length > 0 && <>
          <ChooseAddon saleType={props.saleType} flowType={props.flowType} addons={addons} selectedAddOns={props.selectedAddOns} updateStore={updateStore} isDisable={(isDisplayEsim && cellularSetting?.simType == '' || !isDisplayEsim && !cellularSetting.isValidPhoneNumber)} />
          {spaceBetween('1px', '7.5px 0', '')}
        </>}
        <ChooseCellularServices cellularServices={cellularSetting?.cellularServices} phoneNumber={cellularSetting?.phoneNumber} togglePopUp={toggleCellularServicesPopUp} showPopUp={showCellularServicesPopup} save={saveCellularServices} />
        <PackageForUpgradePopUp showPopup={showPackageForUpgradePopup} togglePopUp={togglePackageForUpgradePopUp} details={props.selectedPackage.upgradeDetails} onClickBtn={handleOnClickPackageForUpgradeBtn} context={props.context} />
      </div>}
  </>);

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className={`sale-page-content ${cellularSetting.showPackages ? 'full-width' : ''}`}>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <CellularSaleFooter isDisplay={isDisplayFooter} leftBtn={leftBtn} rightBtn={rightBtn} bottomLink={bottomLink} formid={formid} errorText={props.errorText} />
      </div>
    </div>
  );


  function handleSubmit(event) {
    event.preventDefault();
  }

  //-------------ChooseCellularPlan-------------
  function handleOnchangePhoneType(phoneType) {
    const phone_type = phoneType ?? cellularSetting.phoneType;
    props.resetCellularTransferPhoneNumberInfo();
    if (phone_type == "newPlan") {
      buildUrlAndOpenSameWindow(props.urlToChangePackage);
    } else if (phone_type == "new") {
      if (cellularSetting.newPhoneNumbers.length == 0) {
        getNewPhoneNumbers(true);
      }
    }
  }

  async function handleClickPhoneType(phoneType) {
    props.setErrorText('');
    props.resetCellularTransferPhoneNumberInfo();
    if (phoneType != "newPlan") {
      gtag4({
        event: phoneType == 'new' ? 'cellular_Step4_NewLineButton' : 'cellular_Step4_NiudLineButton',
        button: phoneType == 'new' ? 'קו חדש' : 'ניוד קו',
        step: '4',
        action: phoneType == 'new' ? 'NewLineButton' : 'NiudLineButton',
        funnel_name: phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
      props.setCellularSetting({ step: 1, phoneType: phoneType, phoneNumber: '', simType: '' });
      if (phoneType == 'new') {
        props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Setting Line New Line Clicked' });
      }
      else {
        props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Setting Line Moving Line Clicked' });
      }
      const isDisplayUpgradePopUp = !props.selectedPackage.isDisplayUpgradePopUp && props.selectedPackage.upgradeDetails.package;
      if (isDisplayUpgradePopUp) {
        props.reportDWH({ actionType: 'PopUp Upgrade Package', status: 'Ongoing', messageText: 'Upgrade Package Displayed' });
        gtag4({
          event: phoneType == 'new' ? 'cellular_Step5_UpgradePackagePopUpImp' : 'cellular_Step5_NiudLinePopup',
          step: '5',
          action: phoneType == 'new' ? 'UpgradePackagePopUpImp' : 'NiudLinePopup',
          funnel_name: phoneType == 'new' ? 'New_Line' : 'Niud_Line',
        });
        props.setIsDisplayPackageUpgradePopUp(true);
        setShowPackageForUpgradePopup(true);
      } else {
        handleOnchangePhoneType(phoneType);
      }
    }
    else {
      props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Setting Line Change Plan Clicked' });
      handleOnchangePhoneType(phoneType);
    }
  }
  //-------------ChooseCellularPlan-------------


  //-------------ChooseNumber-------------
  function handlePhoneChange(data) {
    props.setErrorText('');
    let isValid = data.isValid;
    if (cellularSetting.phoneType == 'new') {
      props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Choose New Number Clicked' });
      gtag4({
        event: 'cellular_Step6_SelectPhoneNum',
        step: '6',
        action: 'SelectPhoneNum',
        funnel_name: 'New_Line',
      });
    }
    else {
      const isPhoneAlreadyExist = props.cellularSettingsList.find(x => x.phoneNumber == data.phoneNumber);
      isValid = data.isValid && !isPhoneAlreadyExist;
      if (isPhoneAlreadyExist) {
        props.setErrorText('אנא בחר מספר אחר, המספר כבר קיים');
      }
    }
    props.resetCellularTransferPhoneNumberInfo();
    props.setCellularSetting({ step: 2, phoneNumber: data.phoneNumber, isValidPhoneNumber: isValid, simType: '' });
  }

  async function getNewPhoneNumbers(clickFromButton) {
    if (!clickFromButton) {
      props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Choose More New Number Clicked' });
      gtag4({
        event: 'cellular_Step6_MoreNumButton',
        button: 'יש פה עוד מספרים חדשים',
        step: '6',
        action: 'MoreNumButton',
        funnel_name: 'New_Line',
      });
    }
    let newPoneNumbers = await props.getPhoneNumbers();
    if (newPoneNumbers.Body?.regularPhoneNumbersList?.length == 0) {
      //TODO: SHOW ERROR MSG
    }
  }
  //-------------ChooseNumber-------------


  //-------------------Addons-------------------
  function groupArrayOfObjects(list) {
    const groups = list?.reduce((groups, item) => {
      if (!groups[item.name]) {
        groups[item.name] = [];
      }
      groups[item.name].push(item);
      return groups;
    }, {});

    let groupArrays = [];
    const isEmpty = (groups == undefined || (Object.keys(groups)?.length === 0 && groups?.constructor === Object));
    if (!isEmpty) {
      groupArrays = Object.keys(groups).map((name) => {
        return {
          name,
          cmsData: groups[name][0]?.cmsData,
          addonsList: groups[name],
        };
      });
    }

    return groupArrays;
  };

  function updateStore(data) {//TODO: SET IN THUNK FOR SYNCHRONIC
    props.updateAddons(data);
    props.setCellularSetting({ step: 4 });
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Pick AddOns Clicked' });
    gtag4({
      event: cellularSetting.phoneType == 'new' ? 'cellular_Step8_AddonButton' : 'cellular_Step7_AddonButton',
      button: data.name,
      content: data.name,
      step: cellularSetting.phoneType == 'new' ? '8' : '7',
      action: 'AddonButton',
      funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
    });
  };
  //-------------------Addons-------------------


  //-------------------ChooseSimType------------------
  function toggleEsimPopUp(isOpenPopup, isCloseFromButton) {
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'What Is eSIM Clicked' });
    if (isOpenPopup) {
      props.reportDWH({ actionType: 'PopUp What is eSIM', status: 'Ongoing', messageText: 'What is eSIM Displayed' });
      gtag4({
        event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_EsimInfoPopUp' : 'cellular_Step6_eSIMInfoPopup',
        step: cellularSetting.phoneType == 'new' ? '7' : '6',
        action: 'EsimInfoPopUp',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
    }
    else {
      if (isCloseFromButton) {
        props.reportDWH({ actionType: 'PopUp What is eSIM', status: 'Ongoing', messageText: 'Close Clicked' })
        gtag4({
          event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_EsimInfoPopUpCloseButton' : 'cellular_Step6_eSIMInfoPopupCloseButton',
          step: cellularSetting.phoneType == 'new' ? '7' : '6',
          action: 'eSIMInfoPopupCloseButton',
          funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
        });
      }
      else {
        props.reportDWH({ actionType: 'PopUp What is eSIM', status: 'Ongoing', messageText: 'X Clicked' })
      }
    }

    setShowEsimPopUp(isOpenPopup);
  }

  function toggleIsMyDeviceSupportESIMPopUp(isOpenPopup, isCloseFromButton) {
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Is My Device Support eSIM Clicked' });
    if (isOpenPopup) {
      // props.reportDWH({ actionType: 'PopUp Is My Device Support eSIM', status: 'Ongoing', messageText: 'Is My Device Support eSIM Displayed' });
      // gtag4({
      //   event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_EsimInfoPopUp' : 'cellular_Step6_eSIMInfoPopup',
      //   step: cellularSetting.phoneType == 'new' ? '7' : '6',
      //   action: 'EsimInfoPopUp',
      //   funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      // });
    }
    else {
      if (isCloseFromButton) {
        // props.reportDWH({ actionType: 'PopUp Is My Device Support eSIM', status: 'Ongoing', messageText: 'Close Clicked' })
        // gtag4({
        //   event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_EsimInfoPopUpCloseButton' : 'cellular_Step6_eSIMInfoPopupCloseButton',
        //   step: cellularSetting.phoneType == 'new' ? '7' : '6',
        //   action: 'eSIMInfoPopupCloseButton',
        //   funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
        // });
      }
      else {
        // props.reportDWH({ actionType: 'PopUp Is My Device Support eSIM', status: 'Ongoing', messageText: 'X Clicked' })
      }
    }

    setShowIsMyDeviceSupportESIMPopUp(isOpenPopup);
  }

  function handleSelectedSimType(value) {
    props.setErrorText('');
    if (value == 'SIM') {
      props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Choose Sim Card Clicked' });
      gtag4({
        event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_SimButton' : 'cellular_Step6_SimButton',
        button: 'SIM רגיל',
        step: cellularSetting.phoneType == 'new' ? '7' : '6',
        action: 'SimButton',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
    }
    else {
      if(props.esimData?.isDisplayWhatIsEsimPopupAuto?.value){
        setShowEsimPopUp(true);
        props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Choose eSim Card Clicked' });
        gtag4({
          event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_EsimButton' : 'cellular_Step6_eSIMButton',
          button: 'eSIM',
          step: cellularSetting.phoneType == 'new' ? '7' : '6',
          action: 'EsimButton',
          funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
        });
      }
    }
    const simType = value == 'SIM' ? getSimTypeCode() : value;
    props.setCellularSetting({ step: 3, simType: simType });
  }

  function handleIsMyPhoneSupportEsim(url, isClickFromPopUp) {
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Do We Suppot eSIm Clicked' });
    if (isClickFromPopUp) {
      props.reportDWH({ actionType: 'PopUp What is eSIM', status: 'Ongoing', messageText: 'Support Esim clicked' });
      gtag4({
        event: cellularSetting.phoneType == 'new' ? 'cellular_Step7_EsimSupportInfoButton' : 'cellular_Step6_eSIMInfoPopupSupportButton',
        button: 'האם המכשיר שלי תומך ב-eSIM?',
        step: cellularSetting.phoneType == 'new' ? '7' : '6',
        action: cellularSetting.phoneType == 'new' ? 'EsimSupportInfoButton' : 'eSIMInfoPopupSupportButton',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
    }
    buildUrlAndOpenWindow(url);
  }
  //-------------------ChooseSimType-------------------

  //-------------------ChooseCellularServices-------------------
  function toggleCellularServicesPopUp(isOpenPopup) {
    setShowCellularServicesPopup(isOpenPopup);

    if (isOpenPopup) {
      props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Content Setting Clicked' });
      gtag4({
        event: cellularSetting.phoneType == 'new' ? 'cellular_Step8_ContentServiceButto' : 'cellular_Step7_ContentServiceButton',
        button: 'הגדרת שירותי תוכן וחיוג בתשלום',
        step: cellularSetting.phoneType == 'new' ? '8' : '7',
        action: 'ContentServiceButton',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
    }
  }

  function saveCellularServices(cellularServices) {
    props.setCellularServices(cellularServices);
    setShowCellularServicesPopup(false);
  }
  //-------------------ChooseCellularServices-------------------

  //-------------------PackageForUpgradePopUp-------------------
  function getUpgradePackage() {
    const upgradeDetailsPackage = props.selectedPackage.upgradeDetails.package;
    const response = {
      offerID: upgradeDetailsPackage.offerID.value,
      saleType: 'cellular',
      title: upgradeDetailsPackage.title.value,
      termsLink: upgradeDetailsPackage.termsLink.value,
      addons: upgradeDetailsPackage.addons.expandedValue,
      isCustomerBasedPackage: !!upgradeDetailsPackage.isCustomerBasedPackage.value,
      isDisplayEsim: !!upgradeDetailsPackage.isDisplayEsim.value,
      upgradeDetails: {}
    }
    return response;
  }

  function togglePackageForUpgradePopUp(isOpenPopup) {
    if (!isOpenPopup) {
      props.reportDWH({ actionType: 'PopUp Upgrade Package', status: 'Ongoing', messageText: 'Upgrade X Clicked' });
      gtag4({
        event: 'cellular_Step5_UpgradePackagePopUpCloseButton',
        step: '5',
        action: 'UpgradePackagePopUpCloseButton',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
      handleOnchangePhoneType();
    }
    setShowPackageForUpgradePopup(isOpenPopup);
  }

  async function handleOnClickPackageForUpgradeBtn(isUpgrade) {
    setShowPackageForUpgradePopup(false);
    if (isUpgrade) {
      gtag4({
        event: 'cellular_Step5_YesUpgradeButton',
        button: props.selectedPackage?.upgradeDetails?.buttonYesText,
        step: '5',
        action: 'YesUpgradeButton',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
      const packageForUpgrade = getUpgradePackage();
      props.reportDWH({ actionType: 'PopUp Upgrade Package', status: 'Ongoing', messageText: 'Upgrade Aapprove Clicked' });
      props.setSelectedPackage(packageForUpgrade);
      props.showAppLoader();
      const catalog = await props.getSalePricesAsync();
      props.hideAppLoader();
      if (catalog.payload?.saleCatalog?.isSuccess) {
        props.updateSelectedCellularSettings();
        handleOnchangePhoneType();
      }
    }
    else {
      props.reportDWH({ actionType: 'PopUp Upgrade Package', status: 'Ongoing', messageText: 'Upgrade No Clicked' });
      gtag4({
        event: 'cellular_Step5_NotUpgradeButton',
        button: props.selectedPackage?.upgradeDetails?.buttonNoText,
        step: '5',
        action: 'NotUpgradeButton',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
      handleOnchangePhoneType();
    }
  }
  //-------------------PackageForUpgradePopUp-------------------


  function checkValidation() {
    let isValid = true;
    const isGolan = process.env.staticWebSiteUrl?.includes('golan');
    if (cellularSetting.phoneType == '') {
      isValid = false;
      props.setErrorText('יש לבצע בחירה כדי להתקדם');
    }
    else if (cellularSetting.phoneNumber == '') {
      isValid = false;
      props.setErrorText('יש לבצע בחירה כדי להתקדם');
    }
    else if (isDisplayEsim && cellularSetting.simType == '') {
      isValid = false;
      props.setErrorText('יש לבצע בחירה כדי להתקדם');
    }
    else if(isGolan && cellularSetting.transferPhoneNumberInfo?.isGolanPhone ){
      isValid = false;
      props.setErrorText('המספר שבחרת לנייד קיים כבר בגולן');
    }
    else if(!isGolan && cellularSetting.transferPhoneNumberInfo?.isCellcomPhone ){
      isValid = false;
      props.setErrorText(`המספר שבחרת לנייד קיים כבר ב${window.Config.brand_Name_HE}`);
    }
    return isValid;
  }


  //-------------------CellularBannerList-------------------
  async function handleOnClickCellularItem(obj) {
    props.setErrorText('');
    const isValid = checkValidation();
    if (isValid) {
      if (cellularSetting.orderId == '') { //TODO: FIX
        await props.addCellular({ isSaveCellularSetting: true });
      }
      else if (cellularSetting.setNewChanges) {
        await props.addCellular({ isSaveCellularSetting: true });
      }
      props.onClickCellularItem({ phoneNumber: obj.item.phoneNumber, index: obj.index });
    }
    else {
      props.setErrorText('אנא השלם את הבחירה');
    }
  }
  //-------------------CellularBannerList-------------------


  function handlePageContinue() {
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'Setting Line Next Clicked' });
    gtag4({
      event: cellularSetting.phoneType == 'new' ? 'cellular_Step9_ContinueButton' : 'cellular_Step8_ContinueButton',
      button: leftBtn.text,
      step: cellularSetting.phoneType == 'new' ? '9' : '8',
      action: 'ContinueButton',
      funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
    });
    props.setErrorText('');
    const isValid = checkValidation();
    if (isValid) {
      props.addCellular({ isAdditionalPhoneNumber: false });
    }
  }

  function handleClickAddPhoneBtn() {
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'More Lines Clicked' });
    gtag4({
      event: cellularSetting.phoneType == 'new' ? 'cellular_Step9_AnotherLineButton' : 'cellular_Step8_AnotherLineButton',
      button: rightBtn.text,
      step: cellularSetting.phoneType == 'new' ? '9' : '8',
      action: 'AnotherLineButton',
      funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
    });
    props.setErrorText('');
    const isValid = checkValidation();
    if (isValid) {
      props.addCellular({ isAdditionalPhoneNumber: true });
    }
  }

  async function handleClickBottomLink() {
    props.reportDWH({ actionType: 'Setting Line', status: 'Ongoing', messageText: 'More Lines Change Package Clicked' });
    gtag4({
      event: cellularSetting.phoneType == 'new' ? 'cellular_Step9_AnotherLineDifferentPackageButton' : 'cellular_Step8_AnotherLineDifferentPackageButton',
      button: bottomLink.text,
      step: cellularSetting.phoneType == 'new' ? '9' : '8',
      action: 'AnotherLineDifferentPackageButton',
      funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
    });
    props.setErrorText('');
    const isValid = checkValidation();
    if (isValid) {
      gtag4({
        event: cellularSetting.phoneType == 'new' ? 'cellular_Step9_AnotherLinePackagesPage' : 'cellular_Step9_AnotherLinePackagesPage',
        step: cellularSetting.phoneType == 'new' ? '9' : '9',
        action: 'AnotherLinePackagesPage',
        funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
      });
      await props.addCellular({ isChangeSelectedPackage: true });
      props.setCellularSetting({ showPackages: true });
      props.reportDWH({ actionType: 'Select Offer', status: 'Ongoing', messageText: 'Pick Different Package Displayed' });
      
      let sale_packages = { expandedValue: props.salePackages?.expandedValue };
      sale_packages.expandedValue = sale_packages?.expandedValue?.filter(x => !x.isCustomerBasedPackage.value);
      
      const orgFamilySalesPackages = await props.getOrgBenefitsAllocations({productsDescription: props.productsDescription, saleType: props.saleType});
      if(!isNullOrEmpty(orgFamilySalesPackages?.payload)){
        sale_packages ={expandedValue: orgFamilySalesPackages?.payload};
      }
      setPackages(sale_packages);
    }
  }

  function onSelectedPackages(salePackage) {
    props.reportDWH({ actionType: 'Select Offer', status: 'Ongoing', messageText: 'Pick Different Package Page Button Clicked' });
    gtag4({
      event: 'cellular_Step9_AnotherLinePackageClick',
      button: salePackage.buttonText,
      package: salePackage.offerID,
      badge: salePackage.banner,
      step: '9',
      action: 'AnotherLinePackageClick',
      funnel_name: cellularSetting.phoneType == 'new' ? 'New_Line' : 'Niud_Line',
    });
    const selectedPackage = {
      ...salePackage,
    };
    props.setSelectedPackage(selectedPackage);
    props.cellularChangePackage();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    orderType: state.saleJetBlock.orderType,
    offerName: state.saleJetBlock.offerName,
    errorText: state.saleJetBlock.errorText,
    cellularSettingsList: state.saleJetBlock.cellular.cellularSettingsList,
    urlToChangePackage: state.saleJetBlock.saleBlockData.urlToChangePackage,
    addons: state.saleJetBlock.saleCatalog?.addons,
    selectedAddOns: state.saleJetBlock.selectedAddOns,
    simPriceList: state.saleJetBlock.cellular.simPriceList,
    selectedPackage: state.saleJetBlock.selectedPackage,
    saleBlockData: state.saleJetBlock.saleBlockData,
    upgradeDisplayList: state.saleJetBlock.cellular.upgradeDisplayList,
    isCustomerBasedPackage: state.saleJetBlock.selectedPackage.isCustomerBasedPackage,
    salePackages: state.saleJetBlock.saleBlockData.salePackages,
    hasCellular: state.saleJetBlock.checkUserResponse?.hasCellular,
    magicLinkParameters: state.authentication?.loginData?.magicLinkParameters,
    esimData: state.saleJetBlock.saleBlockData.esimData,

    //other states
    _authentication: state.authentication,
    cellularPlanForSale : state.familyMemberCellularSale?.cellularPlanForSale,
    productsDescription: state.orgEmployeeFamilySale?.benefitsAllocations,
  };
};

const mapDispatchToProps = {
  goToPage,
  createSaleAsync,
  setErrorText,
  setCellularSetting,
  reportDWH,
  getPhoneNumbers,
  reservePhone,
  setSelectedAddOn,
  getSalePricesAsync,
  resetCellularSettingsPage,
  getCustomerAddresses,
  setCellularServices,
  showAppLoader,
  hideAppLoader,
  addCellular,
  onClickCellularItem,
  setSelectedPackage,
  setIsDisplayPackageUpgradePopUp,
  resetCellularTransferPhoneNumberInfo,
  updateAddons,
  updateSelectedCellularSettings,
  setDisplaySubscriberBasedPackage,
  setSummaryDetails,
  cellularChangePackage,
  setIsLoadingShoppingCart,
  getOrgBenefitsAllocations,
};

export default connect(mapStateToProps, mapDispatchToProps)(CellularSettingsPage);
